/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ age: NonNullable<unknown> }} Queue_OldestInputs */

const en_queue_oldest = /** @type {(inputs: Queue_OldestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`oldest: ${i?.age}`)
};

/**
* | output |
* | --- |
* | "oldest: {age}" |
*
* @param {Queue_OldestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_oldest = /** @type {((inputs: Queue_OldestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_OldestInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_oldest(inputs)
});